import React from 'react';
import './AppBarBiIcon.scss';

const AppBarBiIcon: React.FC = () => {
  return (
    <div className="appbar-icon-root">
      <span className="appbar-icon-img">
        <em className="text-hide">appLayerBiIcon</em>
      </span>
    </div>
  );
};
export default AppBarBiIcon;
